import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialLoader: true,
};

export const systemSlice = createSlice({
  name: "systemSlice",
  initialState,
  reducers: {
    setInitialLoader: (state, action) => {
      return {
        ...state,
        initialLoader: action.payload,
      };
    },
  },
});

export const { setInitialLoader } = systemSlice.actions;

export const systemReducer = systemSlice.reducer;
